import APIKit from '../Allapis/Apikit/apikit'

export const createSEPAPayment = async values => {
  const res = await APIKit.post(`/payments/sepa`, values)
  return res.data
}

export const updatePayment = async (values, slug) => {
  const res = await APIKit.put(`/payments/req/${slug}`, values)
  return res.data
}
